/**
 * This class is used to transform letter from lowercase to uppercase
 */
class CapitalizeLetter {
  /**
   * Capitalize the first letter of a string.
   *
   * @param text The input string.
   * @returns The input string with the first letter capitalized.
   */
  capitalizeFirstLetter = (text: string) => {
    if (typeof text !== 'string') {
      return text;
    }
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
}

const capitalizeLetter = new CapitalizeLetter();
export default capitalizeLetter;
